import {text_mod_4, } from "../text/Text.js";
export const module04 = {
  title:
    "§4. Звукові значення ​букви Я",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_4, },
    ]
  }
